import { useMemo } from "react";
import { mainStreamStore } from "@/data/main-stream-store";
import { useAnnotationsForBlocks } from "@/data/use-annotations";
// ---------------------------------------------------------------------------
// useStreamData
// ---------------------------------------------------------------------------
/**
 * Resolves the homepage stream's block list + pagination handles
 * (single source today: `mainStreamStore`) and warms the
 * user-annotation collection for whichever ids are about to render.
 */
export function useStreamData(options = {}) {
    const { typeFilter } = options;
    const allBlocks = mainStreamStore.useList({ type: typeFilter });
    // Warm the user-annotation collection for whichever block list will
    // actually render in the stream below. The hook dedupes per-id and
    // joins the array into a stable string key, so re-renders that hand
    // back the same id set don't re-trigger the warming.
    const visibleBlockIds = useMemo(() => allBlocks.blocks.map((e) => e.block.id), [allBlocks.blocks]);
    useAnnotationsForBlocks(visibleBlockIds);
    return {
        items: allBlocks.blocks,
        isLoading: allBlocks.isLoading,
        hasMore: allBlocks.hasMore,
        isFetchingNextPage: allBlocks.isFetchingNextPage,
        fetchMore: allBlocks.fetchNextPage,
    };
}
